<template>
  <div style="padding: 16px">
    <h1>使用指南：</h1>
    <p>请将以下成果申报链接，分享给到填报人填写。</p>
    <p>
      1.成果申报链接：
      <a :href="link">
        {{ link }}
      </a>
      <el-button @click="handleClipboard(link, $event)">复制链接</el-button>
    </p>
    <p>2.成果申报二维码：</p>
    <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/JBH/cgsb_qr_test.png" width="200" />
  </div>
</template>

<script setup>
  import handleClipboard from '@/utils/clipboard'
  const link =
    'https://wemeet-h5-dev.wemeet.com/#/applyForm?identity=EXHIBITOR&meetingCode=EX1920026354275885056&meetingType=EXHIBITION&language=CN&appKey=WX_MINI_JBH'
</script>

<style lang="scss" scoped></style>
